import { Table, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import type { LegalEntities } from 'modules/core/store/collections/legalEntities'

import type Taxonomy from 'modules/contracts/store/models/Taxonomy'
import type ExpensesCategory from 'modules/expenses/store/models/Category'
import type { ExpensesCategoriesContractsTaxonomies } from 'modules/payroll_bundle/store/collections/expensesCategoriesContractsTaxonomies'

import ExpenseMappingDropdown from './ExpenseMappingDropdown'

interface TaxonomiesByLegalEntity {
  [key: number]: Taxonomy[]
}

const ExpenseMappingsRow = ({
  expensesCategory,
  legalEntities,
  taxonomiesByLegalEntity,
  expensesCategoriesContractsTaxonomies,
}: {
  expensesCategory: ExpensesCategory
  legalEntities: LegalEntities
  taxonomiesByLegalEntity: TaxonomiesByLegalEntity
  expensesCategoriesContractsTaxonomies: ExpensesCategoriesContractsTaxonomies
}) => {
  const mapping = (legalEntityId: number) =>
    expensesCategoriesContractsTaxonomies.findByExpensesCategoryAndTaxonomies({
      expensesCategoryId: expensesCategory.id,
      taxonomyIds: (taxonomiesByLegalEntity[legalEntityId] || []).map((t) => t.id),
    }) ||
    expensesCategoriesContractsTaxonomies.build({
      expenses_category_id: expensesCategory.id,
    })

  return (
    <Table.Row>
      <Table.Cell sticky={{ position: 'left', delimiter: true }}>
        <Text.Normal>{expensesCategory.attributes.label}</Text.Normal>
      </Table.Cell>
      {legalEntities.map((legalEntity) => (
        <Table.Cell key={legalEntity.id}>
          <ExpenseMappingDropdown
            taxonomies={taxonomiesByLegalEntity[legalEntity.id] || []}
            mapping={mapping(legalEntity.id)}
          />
        </Table.Cell>
      ))}
    </Table.Row>
  )
}

export default observer(ExpenseMappingsRow)
